<template>
  <div class="choice-evaluation">
    <div class="choice-evaluation__task" v-html="evaluation.task"></div>
    <v-radio-group v-model="currentAnswer" class="choice-evaluation__answers">
      <v-radio v-for="(answer, index) in evaluation.answers" :key="index" :value="answer">
        <template slot="label">
          <span v-html="answer.val"></span>
        </template>
      </v-radio>
    </v-radio-group>
    <button class="choice-evaluation__submit" type="button" :disabled="!currentAnswer" @click="sendAnswer()">
      Перевірити відповідь
      <v-icon size="19">mdi-arrow-right</v-icon>
    </button>
  </div>
</template>

<script>
import evaluationEventEnum from '@/enums/evaluationEventEnum';

export default {
  name: 'QuizEvaluation',
  props: {
    evaluation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentAnswer: this.evaluation.answer,
    };
  },
  watch: {
    evaluation(evaluation) {
      this.currentAnswer = evaluation.answer;
    },
  },

  methods: {
    sendAnswer() {
      this.$emit('evaluateEvent', {
        type: evaluationEventEnum.SEND_ANSWER,
        data: {
          answer: this.currentAnswer,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.choice-evaluation__task { color: var(--theme-banner-text); font-size: 18px; font-weight: 700; line-height: 1.55; margin-bottom: 16px; }.choice-evaluation__task::v-deep p { margin: 0 0 8px; }
.choice-evaluation__answers { margin: 0; max-width: 800px; padding: 0; }.choice-evaluation__answers::v-deep .v-radio { background: var(--theme-surface-soft); border: 1px solid var(--theme-border-decorative); border-radius: 11px; margin: 0 0 9px; padding: 11px 13px; }.choice-evaluation__answers::v-deep .v-radio.v-item--active { background: var(--theme-banner-background); border-color: var(--theme-header-background); }.choice-evaluation__answers::v-deep .v-radio.v-item--active .v-icon { color: var(--theme-header-background) !important; }.choice-evaluation__answers::v-deep .v-messages { display: none; }
.choice-evaluation__submit { align-items: center; background: var(--theme-header-background); border: 1px solid var(--theme-header-background); border-radius: 10px; color: var(--theme-header-text); cursor: pointer; display: inline-flex; font-size: 14px; font-weight: 800; gap: 8px; min-height: 44px; padding: 10px 18px; }.choice-evaluation__submit::v-deep .v-icon { color: currentColor !important; }.choice-evaluation__submit:hover:not(:disabled) { background: var(--theme-banner-background); color: var(--theme-banner-text); }.choice-evaluation__submit:disabled { background: var(--theme-surface-soft); border-color: var(--theme-border-decorative); color: var(--text-secondary); cursor: not-allowed; opacity: .55; }
@media (max-width: 600px) { .choice-evaluation__task { font-size: 16px; }.choice-evaluation__submit { justify-content: center; width: 100%; } }
</style>
